const angular = require('angular')
const skeletonLoading = require('./skeletonLoading')
/* Directives */
module.exports = angular.module('hxphone.directives', [])

// 提供全局的resize方式，将resize函数以闭包形式发送到此处即可
  .directive('resize', ['$window', '$document', '$timeout', '$rootScope', function ($window, $document, $timeout, $rootScope) {
    return function (scope, element) {
      let funcs = []
      const optTypes = []
      const delays = []

      let lastClientRect = getBodyClientRect()

      function getBodyClientRect() {
        const body = $document.find('body')[0]
        return {
          width: body.clientWidth,
          height: body.clientHeight
        }
      }

      function handler() {
        const newClientRect = getBodyClientRect()
        const oldClientRect = lastClientRect
        lastClientRect = newClientRect

        for (let i = 0; i < funcs.length; i++) {
          if (optTypes[i] == 0) {
            doApply(i)
          } else {
            if (optTypes[i] == 1) {
              if (newClientRect.width < oldClientRect.width || newClientRect.height < oldClientRect.height) {
                doApply(i)
              }
            } else {
              if (newClientRect.width > oldClientRect.width || newClientRect.height > oldClientRect.height) {
                doApply(i)
              }
            }
          }
        }

        function doApply(i) {
          $timeout(function () {
            funcs[i].apply(this)
          }, delays[i])
        }
      }

      /**
       * @param func
       * @param optType 0（只要resize）、1（resize变小）、2（resize变大） 响应的时机
       * @param delay 延时执行的时机
       */
      $rootScope.$on('GLOBAL_ADD_WINDOW_RESIZE_FUN', function ($event, func, optType, delay) {
        optType = optType || 0
        delay = delay || 0

        funcs.push(func)
        optTypes.push(optType)
        delays.push(delay)
      })

      $rootScope.$on('GLOBAL_REMOVE_WINDOW_RESIZE_FUN', function ($event, func) {
        for (let i = 0; i < funcs.length; i++) {
          if (func === funcs[i]) {
            funcs.splice(i, 1)
            optTypes.splice(i, 1)
            delays.splice(i, 1)
          }
        }
      })

      scope.$on('destroy', function ($event) {
        funcs = []
        $window.window.onresize = angular.noop()
      })

      $window.window.onresize = handler
    }
  }])
  // 非pad模式下添加遮罩
  .directive('sideBackdrop', ['$ionicSideMenuDelegate', '$ionicHistory', function ($ionicSideMenuDelegate) {
    return {
      restrict: 'A',
      link: function (scope, elem, attr) {
        if (scope.isPadMode) return

        scope.$watch(function () {
          return $ionicSideMenuDelegate.isOpen()
        }, function (isOpen) {
          elem[isOpen ? 'addClass' : 'removeClass']('f_backdrop')
        })
      }
    }
  }])
  // 支持pad模式下关闭/展开侧边栏
  .directive('menuToggle', [function () {
    return {
      restrict: 'AC',
      link: function(scope, $element) {
        const sideMenuCtrl = $element.inheritedData('$ionSideMenusController')
        if (!scope.isPadMode || !sideMenuCtrl) return

        $element.bind('click', function() {
          const isAsideExposed = sideMenuCtrl.isAsideExposed()
          sideMenuCtrl.exposeAside(!isAsideExposed)
        })
      }
    }
  }])
  // 支持pad模式下自动展开侧边栏
  .directive('exposeAsideWhen', ['$timeout', function ($timeout) {
    return {
      restrict: 'AC',
      link: function(scope, $element) {
        const sideMenuCtrl = $element.inheritedData('$ionSideMenusController')
        if (!scope.isPadMode || !sideMenuCtrl) return

        $timeout(sideMenuCtrl.exposeAside.bind(sideMenuCtrl, true)) // ionic的exposeAsideWhen编译的时候，self.left尚未完成初始化导致侧边栏无法展开
      }
    }
  }])
  .directive('menuClose', ['$ionicHistory', '$timeout', function($ionicHistory, $timeout) {
    // https://github.com/driftyco/ionic/issues/4145
    return {
      restrict: 'AC',
      link: function($scope, $element) {
        $element.bind('click', function() {
          const sideMenuCtrl = $element.inheritedData('$ionSideMenusController')
          if (sideMenuCtrl) {
            $ionicHistory.nextViewOptions({
              historyRoot: true,
              disableAnimate: true,
              expire: 300
            })
            // if no transition in 300ms, reset nextViewOptions
            // the expire should take care of it, but will be cancelled in some
            // cases. This directive is an exception to the rules of history.js
            $timeout(function() {
              $ionicHistory.nextViewOptions({
                historyRoot: false,
                disableAnimate: false
              })
            }, 300)
            sideMenuCtrl.close()
          }
        })
      }
    }
  }])
  .directive('autoFocusCustom', [function () {
    return {
      restrict: 'A',
      scope: {},
      link: function (scope, elem, attr) {
        const $input = angular.element(elem)
        if (attr.autoFocusCustom) {
          if (attr.autoFocusCustom == 'true') {
            $input.ready(function () {
              elem[0].focus()
              elem[0].selectionStart = 0
              elem[0].selectionEnd = 0
            })
          }
        }
      }
    }
  }])
  .directive('alignTitle', [
    function () {
      return {
        restrict: 'A',
        link: function ($scope, elem) {
          if (elem[0].tagName.toLowerCase() === 'ion-header-bar') {
            const title = elem[0].querySelector('.title')
            const buttons = elem[0].querySelectorAll('.buttons')
            const ctrl = angular.element(elem[0]).data().$ionHeaderBarController

            /** listen to the change of title */
            title && $scope.$watch(function () {
              return title.innerHTML
            }, function () {
              ctrl.align()
            })

            /** listen to the change of button */
            angular.forEach(buttons, function (item) {
              $scope.$watch(function () {
                return item.innerHTML
              }, function () {
                ctrl.align()
              })
            })
          }
        }
      }
    }
  ])
  .directive('customImage', [
    '$rootScope',
    function ($rootScope) {
      return {
        restrict: 'A',
        link: function ($scope, elem, attr) {
          if (!$rootScope.settings) {
            return
          }

          let customImageUrl = $rootScope.settings[attr.customImage]
          if (customImageUrl && /\.(?:png|jpe?g|gif)$/gi.test(customImageUrl)) {
            /** use query parameter to avoid cache */
            console.log('custom logo: ', customImageUrl)
            customImageUrl += '?_t=' + new Date().valueOf()
            angular.element(elem).css('background-image', 'url(' + customImageUrl + ')')
          }
        }
      }
    }
  ])
  .directive('skeletonLoading', skeletonLoading)



// WEBPACK FOOTER //
// ./src/js/directives/module.js